import { SaveButton } from "components/Buttons"
import {
  CheckboxField,
  CountryCode,
  MultipleSelectField,
  RadioField,
  SingleSelectField,
  TagsMultiSelect,
  TextField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import {
  ADMIN_TYPE,
  ASSIGN_ACOUNT_TYPES,
  BUSINESS_UNIT_TYPE,
  USER_TYPE,
} from "constants/people"
import React from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import { Field, formValueSelector, reduxForm } from "redux-form"
import asyncValidate from "./userFormAsyncValidation"
import validate from "./userFormValidation"
import { shouldDisplaySSN } from "./utils"

let CreateUserForm = props => {
  const {
    handleSubmit,
    loading,
    businessUnits,
    assignAcountType,
    peopleType,
    metaTags,
    onTagCreate,
    roles,
    vendorId,
  } = props

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col lg={6}>Select User type:</Col>
      </Row>
      <Row className="form-group mt-3">
        <Col>
          <Field
            name={"people_type"}
            label={"Admin User"}
            component={RadioField}
            type="radio"
            value={ADMIN_TYPE}
          />
        </Col>
        <Col>
          <Field
            name={"people_type"}
            label={"Normal User"}
            component={RadioField}
            type="radio"
            value={USER_TYPE}
          />
        </Col>
      </Row>
      <Row className="form-group mt-3">
        <Col>
          <Field
            name={"first_name"}
            label={
              <span>
                First Name<span className="text-danger">*</span>
              </span>
            }
            placeholder="First Name"
            component={TextField}
          />
        </Col>
        <Col>
          <Field
            name={"last_name"}
            label={
              <span>
                Last Name<span className="text-danger">*</span>
              </span>
            }
            placeholder="Last Name"
            component={TextField}
          />
        </Col>
      </Row>
      <Row className="form-group mt-3">
        <Col>
          <Field
            name={"email_address"}
            label={
              <span>
                Email Address<span className="text-danger">*</span>
              </span>
            }
            placeholder="Email Address"
            component={TextField}
          />
        </Col>
        <Col>
          <Field
            name={"display_name"}
            label={
              <span>
                Display Name<span className="text-danger"></span>
              </span>
            }
            placeholder="Display Name"
            component={TextField}
          />
        </Col>
      </Row>
      {shouldDisplaySSN(vendorId) && peopleType !== ADMIN_TYPE && (
        <Row className="form-group mt-3">
          <Col>
            <Field
              name={"last_4_ssn"}
              label={<span>Last 4 SSN</span>}
              placeholder="Last 4 SSN"
              component={TextField}
            />
          </Col>
        </Row>
      )}
      <Row className="form-group mt-3">
        <Col xs={"auto"}>
          <Field
            name={"country_code"}
            label={"Country Code"}
            component={CountryCode}
            maxWidth="110px"
            disabled={true}
            editable={false}
            country="us"
          />
        </Col>
        <Col>
          <Field
            name={"phone_number"}
            label={"Phone Number"}
            component={TextField}
          />
        </Col>
      </Row>
      <Row className="form-group mt-3">
        <Col>
          <Field
            name={"tags"}
            label={<span>Tags</span>}
            placeholder="Tags"
            component={TagsMultiSelect}
            create={onTagCreate}
            options={metaTags.map(({ id, tag }) => ({ value: id, label: tag }))}
          />
        </Col>
      </Row>
      <Row className="form-group mt-3">
        <Col>
          <Field
            name={"assign_acount_type"}
            label={"Assign Account Type"}
            component={SingleSelectField}
            options={ASSIGN_ACOUNT_TYPES}
            disabled={peopleType !== ADMIN_TYPE}
          />
        </Col>
        <Col>
          <Field
            name={"business_unit"}
            label={"Business Unit"}
            component={SingleSelectField}
            options={businessUnits.map(bUnit => ({
              value: bUnit.id,
              label: bUnit.name,
            }))}
            disabled={
              peopleType !== ADMIN_TYPE ||
              assignAcountType !== BUSINESS_UNIT_TYPE
            }
          />
        </Col>
      </Row>
      <Row className="form-group mt-3">
        <Col>
          <Field
            name={"assign_roles"}
            label={"Assign Roles"}
            component={MultipleSelectField}
            disabled={peopleType !== ADMIN_TYPE}
            options={roles.map(role => ({ value: role.id, label: role.name }))}
          />
        </Col>
      </Row>

      <Row className="form-group mt-3">
        <Col>
          <Field
            name={"send_invite"}
            label={"Send invite"}
            component={CheckboxField}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <label>
            Check to send INVITE to the Mobile App now. If unchecked, it will
            add the user but not send an invite to the Mobile App.
          </label>
        </Col>
      </Row>

      <Row className="form-group mt-3">
        <Col>
          <SaveButton content={"Add"} loading={loading} />
        </Col>
      </Row>
    </form>
  )
}

CreateUserForm = reduxForm({
  form: FORM_NAMES.CREATE_USER, // must be unique
  validate,
  asyncValidate,
  asyncChangeFields: ["email_address"],
})(CreateUserForm)

const selector = formValueSelector(FORM_NAMES.CREATE_USER)

function mapStateToProps(state) {
  const { people_type: peopleType, assign_acount_type: assignAcountType } =
    selector(state, "people_type", "assign_acount_type")
  return {
    peopleType,
    assignAcountType,
  }
}

CreateUserForm = connect(mapStateToProps)(CreateUserForm)

export default CreateUserForm
